module.exports = __webpack_public_path__ + "img/management-approval.a6250405.png";